const getTextWidth = (() => {
	const container = document.createElement("canvas");
	const context = container.getContext("2d");

	return function (inputText?: string | number | null, backupRatio = 0.5, targetRef?: React.RefObject<HTMLElement | null>): number {
		let width = 0;
		let text = inputText ?? "";
		text = text.toString();
		const targetNode = targetRef?.current ?? document.body;
		const computedStyle = window.getComputedStyle(targetNode);

		if (context) {
			context.font = computedStyle.getPropertyValue("font");
			width = context.measureText(text).width;

			return Math.ceil(width);
		}
		const fontSize = parseFloat(computedStyle.getPropertyValue("font-size"));

		return Math.ceil(fontSize * backupRatio * text.length);
	};
})();

export default getTextWidth;
